/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMap = createReactComponent("outline", "map", "IconMap", [["path", { "d": "M3 7l6 -3l6 3l6 -3v13l-6 3l-6 -3l-6 3v-13", "key": "svg-0" }], ["path", { "d": "M9 4v13", "key": "svg-1" }], ["path", { "d": "M15 7v13", "key": "svg-2" }]]);

export { IconMap as default };
//# sourceMappingURL=IconMap.mjs.map
